import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { colors } from 'utils/styles/theme';

interface WrapperProps {
  hoverColor?: string;
}

interface ListItemProps {
  isActive: boolean;
  isHovering: boolean;
  isSetActiveElement: boolean;
}

export const Wrapper = styled(motion.ul)<WrapperProps>`
  &:hover {
    ${({ hoverColor }) =>
      hoverColor?.length &&
      css`
        li:hover h4:hover {
          color: ${colors[hoverColor] ?? hoverColor};
        }
      `}

    li:not(:hover) {
      opacity: 0.2;
    }
  }
`;

export const ListItem = styled(motion.li)<ListItemProps>`
  transition: opacity 0.4s ease-in-out;

  & h4 {
    transition: color 0.4s ease-in-out;
  }

  cursor: pointer;

  ${({ isActive, isHovering, isSetActiveElement }) =>
    isActive
      ? css`
          opacity: 1 !important;
        `
      : css`
          /* ${isSetActiveElement
            ? 'opacity: 0.2;'
            : isHovering
            ? 'opacity: 0.2;'
            : 'opacity: 1;'} */
          ${isSetActiveElement ? 'opacity: 0.2;' : 'opacity: 1;'}

          &:hover {
            opacity: 1;
          }
        `}
`;
